module.exports = __webpack_public_path__ + "static/media/FTT.aff93a27.svg";